import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Dialog, DialogContentType, DialogFooterType, IconNames, Text } from '@dotcom/crown-ui';
import { getCurrentRegion } from '../../../../regional-config/get-regional-config';
import { USPSValidationDialogTypes } from './usps-validation-dialog-types';
import styles from './usps-validation-dialog.module.scss';

export const USPSValidationDialog = ({
  isOpen,
  onClose,
  title,
  message,
  onConfirm,
  children,
}: USPSValidationDialogTypes) => {
  const { t } = useTranslation();
  const region = getCurrentRegion();

  const handleClick = () => {
    onConfirm();
  };

  return (
    <Dialog
      type={DialogContentType.FeatureModal}
      isOpen={isOpen}
      title={title}
      onClose={onClose}
      dialogClassName={styles['usps-validation-dialog']}
      testId={'usps-validation-dialog'}
      accentIcon={IconNames.AddressBookBold}
      hasGrayBackground={false}
      locale={region}
      footerType={DialogFooterType.SingleButton}
      actionButton={
        <Button testId={'dialog-confirm-button'} onClick={handleClick}>
          {t('addressConfirmation.confirmatonButtonLabel')}
        </Button>
      }
    >
      <header data-testid="usps-validation-dialog-header">
        <Text as="span" className={styles['description']}>
          {message}
        </Text>
      </header>

      <section data-testid="usps-validation-dialog-content">{children}</section>
    </Dialog>
  );
};
